import Users from './containers/Users';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';
export const usersRoutes = [
  {
    path: '/users',
    component: pageLayoutHoc(Users),
    key: 'users',
  },
];
